import { render, staticRenderFns } from "./AdminProductsTable.vue?vue&type=template&id=7fa8ddcf&scoped=true&"
import script from "./AdminProductsTable.vue?vue&type=script&lang=js&"
export * from "./AdminProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8ddcf",
  null
  
)

export default component.exports